import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%"
}
const _hoisted_2 = ["stroke", "opacity"]


export default /*#__PURE__*/_defineComponent({
  __name: 'svg-circle-dasharray',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' },
    opacitys: { default: '1' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      r: "calc(50% - 1px) ",
      cx: "50%",
      cy: "50%",
      "stroke-width": "2",
      stroke: _ctx.controlColor,
      "stroke-dasharray": "6, 6",
      "stroke-dashoffset": "3",
      fill: "transparent",
      opacity: _ctx.opacitys
    }, null, 8, _hoisted_2)
  ]))
}
}

})